/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Generating_WaveformInputs */



/**
* | output |
* | --- |
* | "Generating Waveform..." |
*
* @param {Timeline_Generating_WaveformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_generating_waveform = /** @type {((inputs?: Timeline_Generating_WaveformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Generating_WaveformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generation de la forme d'onde...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wellenformerzeugung...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione della forma d'onda...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Генерация волновой формы...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando forma de onda...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("生成波形...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("波形を生成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वेवफॉर्म जनरेट हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerando forma de onda...")
	return /** @type {LocalizedString} */ ("Generating Waveform...")
});